const formatMoney = (money: Money, locale: string | null = null) => {
  if (!money || !money.amount || !money.currency) {
    return '';
  }
  const locales = locale ?? window.Laravel.locale ?? 'en-US';

  return new Intl.NumberFormat(locales, {
    style: 'currency',
    currency: money.currency
  }).format(money.amount);
}

const equals = (money1: Money | null, money2: Money | null) => {
  if (!money1 && !money2) return true;
  if (!money1 || !money2) return false;
  return money1.amount === money2.amount && money1.currency === money2.currency;
}

interface Money {
  amount: number;
  currency: string;
}

export { formatMoney, equals };

export type { Money };